import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { Text } from '@atlaskit/primitives/compiled';
import { N20 } from '@atlaskit/theme/colors';
import Toggle from '@atlaskit/toggle';
export var ErrorSection = function ErrorSection(_ref) {
  var errorDetails = _ref.errorDetails;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showErrorDetails = _useState2[0],
    setShowErrorDetails = _useState2[1];
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ErrorSectionLabel, null, /*#__PURE__*/React.createElement(Text, {
    as: "p"
  }, "Show error details:"), /*#__PURE__*/React.createElement(Toggle, {
    isChecked: showErrorDetails,
    onChange: function onChange() {
      setShowErrorDetails(!showErrorDetails);
    }
  })), showErrorDetails && /*#__PURE__*/React.createElement(ErrorDetailsWrapper, null, /*#__PURE__*/React.createElement("code", null, errorDetails)));
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var ErrorSectionLabel = styled.div({
  display: 'flex',
  marginTop: "var(--ds-space-250, 20px)",
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
  '> p': {
    marginTop: "var(--ds-space-025, 2px)"
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
var ErrorDetailsWrapper = styled.div({
  backgroundColor: "var(--ds-background-neutral, ".concat(N20, ")"),
  padding: "var(--ds-space-100, 8px)",
  font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});